// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__U74AM","main":"Layout_main__wz7HS"};